import React, {FC, useEffect} from "react";
import QuicktipLobby from "./QuicktipLobby";
import SmartbetLobby from "./SmartbetLobby";
import SuperbetLobby from "./SuperbetLobby";
import QuickbetLobby from "./QuickbetLobby";
import JackpotLobby from "./JackpotLobby";
import QuickbetXLobby from "./QuickbetXLobby";
import LobbyWidget from "../Components/Widget/LobbyWidget";
import {useLocation} from "react-router-dom";
import './Lobby.css'
const toAbsoluteUrl = (pathname: string) => process.env.PUBLIC_URL + pathname;
const Lobby: FC = () => {
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const mode = params.get('mode')
    const ticketOpenMode = params.get('ticketOpenMode')
    const types = params.get('type')
        ?.split(',')
        .map((type) => parseInt(type, 10))
        .filter((type) => !isNaN(type)) || [];

    const sourceParams = params.get('source');
    const style = params.get('style');
    const authData = params.get('token');
    const atagVal = params.get('atag');

    if (authData) {
        localStorage.setItem('token', authData);
    } else {
        localStorage.removeItem('token');
    }
    const shouldRenderAll = types.length === 0;
    useEffect(() => {
        if (mode === 'iframe') {
            const sendHeight = () => {
                const height = document.body.scrollHeight;

                window.parent.postMessage(
                    {
                        type: "SET_IFRAME_HEIGHT",
                        height
                    },
                    "*"
                );
            };

            sendHeight();
            const observer = new ResizeObserver(() => {
                sendHeight();
            });

            observer.observe(document.body);

            return () => {
                observer.disconnect();
            };
        }
    }, [mode]);
    return (
        <>
            {
                mode === 'widget'
                    ?
                    <LobbyWidget
                        types={types}
                        atagParams={atagVal}
                        sourceParams={sourceParams}
                    />
                    :
                    <div className={`Lobby-container ${style ? style : 'lite'}`}>
                        <main
                            className={mode === 'iframe' ? '' : "pt-2 pb-3"}
                            style={{
                                backgroundImage: mode !== 'iframe' ? `url(${toAbsoluteUrl('/assets/img/bg/lobby-bg.webp')})` : 'none',
                                backgroundSize: '100% 100%',
                                backgroundRepeat: 'no-repeat',
                                minHeight: '100vh',
                            }}
                        >
                            <div className={mode === 'iframe' ? 'container-fluid' : 'container'}>
                                <div className="row">
                                    {(shouldRenderAll || types.includes(1)) &&
                                        <QuicktipLobby
                                            mode={mode}
                                            ticketOpenMode={ticketOpenMode}
                                            sourceParams={sourceParams}
                                            atagParams={atagVal}/>}
                                    {(shouldRenderAll || types.includes(2)) &&
                                        <SmartbetLobby mode={mode} sourceParams={sourceParams} ticketOpenMode={ticketOpenMode} atagParams={atagVal}/>}
                                    {(shouldRenderAll || types.includes(3)) &&
                                        <SuperbetLobby
                                            mode={mode}
                                            sourceParams={sourceParams}
                                            ticketOpenMode={ticketOpenMode}
                                            atagParams={atagVal}/>}
                                    {(shouldRenderAll || types.includes(4)) &&
                                        <QuickbetLobby
                                            mode={mode}
                                            sourceParams={sourceParams}
                                            ticketOpenMode={ticketOpenMode}
                                            atagParams={atagVal}/>}
                                    {(shouldRenderAll || types.includes(5)) &&
                                        <JackpotLobby
                                            mode={mode}
                                            sourceParams={sourceParams}
                                            ticketOpenMode={ticketOpenMode}
                                            atagParams={atagVal}/>}
                                    {(shouldRenderAll || types.includes(6)) &&
                                        <QuickbetXLobby
                                            mode={mode}
                                            sourceParams={sourceParams}
                                            ticketOpenMode={ticketOpenMode}
                                            atagParams={atagVal}/>}
                                </div>
                            </div>
                        </main>
                    </div>
            }
        </>

    );
};

export default Lobby;
